import { Ref, ref, computed } from "vue"
export default function setUp(elm: Ref<HTMLElement | undefined>) {
  let width = ref(elm.value ? elm.value.clientWidth : 0)
  let height = computed(() => width.value * 0.55)
  let containerClassList = computed(() => {
    return {
      small: width.value < 300,
      normal: width.value < 700 && width.value > 299,
      relative: true
    }
  })
  let handleResize = () => {
    width.value = elm.value ? elm.value.clientWidth : 0
  }
  return { width, height, containerClassList, handleResize }
}
